export default {
p19b17dc0: "M9.375 11.25L5.625 7.5L9.375 3.75",
p5646280: "M5.625 11.25L9.375 7.5L5.625 3.75",
pa029e20: "M3.25 4.875L6.5 8.125L9.75 4.875",
}
